"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.bob = void 0;
const defineChain_js_1 = require("../../utils/chain/defineChain.js");
exports.bob = (0, defineChain_js_1.defineChain)({
    id: 60808,
    name: 'BOB',
    nativeCurrency: {
        decimals: 18,
        name: 'ETH',
        symbol: 'ETH',
    },
    rpcUrls: {
        default: {
            http: ['https://rpc.gobob.xyz'],
            webSocket: ['wss://rpc.gobob.xyz'],
        },
    },
    blockExplorers: {
        default: {
            name: 'Blockscout',
            url: 'https://explorer.gobob.xyz',
        },
    },
    contracts: {
        multicall3: {
            address: '0x63f8279bccDb75c0F38e0CD6B6A0c72a0a760FF9',
            blockCreated: 457045,
        },
    },
    testnet: false,
});
//# sourceMappingURL=bob.js.map